<template>
    <div>
        <v-row>
            <v-col cols="12" sm="6" offset-sm="3" class="text-center">
                <div class="d-flex align-center justify-center">
                    <strong class="mr-4 flex-1 text-right" :class="typeGraph=='products' ? 'primary--text' : ''">{{ $t('Productos') }}</strong>
                    <v-switch
                        v-model="typeGraph"
                        inset
                        :true-value="'profits'"
                        :false-value="'products'"
                        @change="changeTypeGraph"
                        color="grey"
                    ></v-switch>
                    <strong class="flex-1 text-left" :class="typeGraph=='profits' ? 'primary--text' : ''">{{ $t('Ganancias') }}</strong>
                </div>
                <div class="d-flex align-center justify-center">
                    <strong class="mr-4 flex-1 text-right" :class="type==='graphs' ? 'primary--text' : ''">{{ $t('Graficos') }}</strong>
                    <v-switch
                        v-model="type"
                        inset
                        :true-value="'results'"
                        :false-value="'graphs'"
                        @change="changeTypeGraph"
                        color="grey"
                    ></v-switch>
                    <strong class="flex-1 text-left" :class="type==='results' ? 'primary--text' : ''">{{ $t('Resultados') }}</strong>
                </div>
            </v-col>
        </v-row>

        <!-- graphics -->
        <v-row>
            <v-col cols="12" sm="8" offset-sm="2" v-if="typeGraph==='profits' && type==='results'">
                <profits-results v-if="showGraph" :money="money"/>
            </v-col>
            <v-col cols="12" sm="10" offset-sm="1" v-if="typeGraph==='products' && type==='results'">
                <products-results v-if="showGraph" :money="money"/>
            </v-col>
            <v-col cols="12" sm="8" offset-sm="2" v-if="typeGraph==='profits' && type==='graphs'">
                <profits-graphs v-if="showGraph"/>
            </v-col>
            <v-col cols="12" sm="8" offset-sm="2" v-if="typeGraph==='products' && type==='graphs'">
                <products-graphs v-if="showGraph"/>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            overlay: true,
            showGraph: false,
            typeGraph: 'profits', //products
            type: 'results' //graphs
        }
    },
    props: ['money'],
    mounted() {
        setTimeout(() => {
            this.showGraph = true
            this.overlay = false
        }, 300);
    },
    methods: {
        changeTypeGraph() {
            this.showGraph = false
            this.overlay = true
            setTimeout(() => {
                this.showGraph = true
                this.overlay = false
            }, 300);
        }
    },
}
</script>
